import { render, staticRenderFns } from "./Wizard-Language.vue?vue&type=template&id=d70416d8&scoped=true"
import script from "./Wizard-Language.vue?vue&type=script&lang=js"
export * from "./Wizard-Language.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Language.vue?vue&type=style&index=0&id=d70416d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70416d8",
  null
  
)

export default component.exports